import { DataOperationUtil } from '../';
import { Injectable } from '@angular/core';
import { JsonUtil } from '../util/json.util';
import { NecLocalStorageService } from '../localStorage/local-storage.service';



@Injectable()
export class NecRouterDataService {
  private static keys: string[] = [];

  constructor(private ls: NecLocalStorageService) {
  }

  /**
   * æ ¹æ®æä¾çæ°æ®ç±»åï¼ä»localStorageä¸­è§£æåºæ°æ®
   */
  getRouterData(key: string, classReference: { new(): any }): any {
    return JsonUtil.jsonConvert(this.getRouterDataNormal(key), classReference);
  }

  getRouterDataNormal(key: string): any {
    return this.ls.get(key);
  }

  /**
   * ç¼å­è·¯ç±åæ°,å¹¶ååºäºä»¶
   */
  setRouterData(key: string, data: any) {
    this.resetKeys(key);
    this.ls.set(key, data);
  }

  delRouterData(key) {
    this.ls.del(key);
  }

  private resetKeys(key: string) {
    if (DataOperationUtil.arrayIncludes(NecRouterDataService.keys, key)) {
      return;
    }

    if (NecRouterDataService.keys.length === 10) {
      this.delRouterData(NecRouterDataService.keys[9]);
      NecRouterDataService.keys.splice(9, 1);
    } else {
      NecRouterDataService.keys.unshift(key);
    }
  }
}
